import * as Fields from 'support/fields'
import React from 'react'
import { Fieldset } from 'layouts'

export function VacationRequestEditFields () {
  return (
    <Fieldset cols={1} innerClassName='mt-4'>
      <Fields.Select enum='vacation_request_type' name='type'/>
      <Fields.Date name='requested_start_at'/>
      <Fields.Date name='requested_end_at'/>
      <Fields.TextArea name='note'/>
    </Fieldset>
  )
}
